import type { AnnotationLabelT, AnswerT, DynamicAnnotationConfigT } from '../../../../common/types/types';
import { getRandomId } from '../../../../common/utils/utils';
type DynamicAnswerSpan = {
  frameSpan: {
    start: number;
    end: number;
  };
  answers: AnswerT;
};
export const calculateDynamicFieldRanges = (dynamicAnswers: DynamicAnswerSpan[], annotationId: string, annotationLabel: AnnotationLabelT, annotationType: string): DynamicAnnotationConfigT[] => {
  return dynamicAnswers.map(span => ({
    frameStart: span.frameSpan.start + 1,
    frameEnd: span.frameSpan.end + 1,
    annotation: {
      id: annotationId,
      annotationLabel,
      annotationType,
      metadata: {
        answers: span.answers
      }
    },
    isValid: true,
    id: getRandomId(),
    savedToStore: true
  }));
};